import { IdentityDoc } from '../../services/IdentityDoc';

const identityItem = {
    GUB_BP_Document_ID: '',
    C_BPartner_ID: '',
    Description: '',
    IdentityDocType: '',
    DocumentNumber: '',
    ExpiryDate: '',
    C_Country_ID: '',
    RegionName: '',
    Nationality_ID: '',
    Profession: '',
    IssueDate: '',
    IsActive: '',
    Status: ''
};

function initialState() {
    return {
        partnerId: '',
        item: identityItem,
        items: {},
        documentSelector: {},
        docsLoading: false,
    }
}

const getters = {
    item: state => state.item,
    documentSelector: state => state.documentSelector || [],
    documentsExists: state => Object.keys(state.documentSelector).length > 0,
    docsLoading: state => state.docsLoading
};

const actions = {
    store({ commit, state, dispatch }) {
        return new Promise((resolve, reject) => {
            IdentityDoc.store(state.item)
                .then(response => {
                    commit('setItems', response.data);
                    resolve()
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    fetch({ commit, dispatch }, id) {
        commit('setPartnerId', id);
        commit('setLoading', true);
        IdentityDoc.fetch(id)
            .then(response => {
                commit('setItems', response.data)
            })
            .finally(() => {
                commit('setLoading', false)
            })
    },
    setGUB_BP_Document_ID({ commit, state }, value) {
        let identity = state.items[value] || identityItem;
        identity.C_BPartner_ID = state.partnerId;
        commit('setItem', identity)
    },
    setIdentityDocType({ commit }, value) {
        commit('setIdentityDocType', value)
    },
    setC_BPartner_ID({ commit }, value) {
        commit('setC_BPartner_ID', value)
    },
    setDescription({ commit }, value) {
        commit('setDescription', value)
    },
    setDocumentNumber({ commit }, value) {
        commit('setDocumentNumber', value)
    },
    setExpiryDate({ commit }, value) {
        commit('setExpiryDate', value)
    },
    setC_Country_ID({ commit }, value) {
        commit('setC_Country_ID', value)
    },
    setRegionName({ commit }, value) {
        commit('setRegionName', value)
    },
    setNationality_ID({ commit }, value) {
        commit('setNationality_ID', value)
    },
    setProfession({ commit }, value) {
        commit('setProfession', value)
    },
    setIssueDate({ commit }, value) {
        commit('setIssueDate', value)
    },
    resetState({ commit }) {
        commit('resetState')
    },
    resetItem({ commit, state }) {
        let identity = Object.assign({}, identityItem);
        identity.C_BPartner_ID = state.partnerId;
        commit('setItem', identity);
    }
};

const mutations = {
    setPartnerId(state, value) {
        state.partnerId = value;
    },
    setItem(state, item) {
        state.item = item
    },
    setItems(state, items) {
        state.item = identityItem;
        state.items = items;
        state.documentSelector = {};
        let index = 1;
        for (let di in state.items) {
            if (!state.item.GUB_BP_Document_ID) {
                state.item = state.items[di];
            }
            state.documentSelector[di] = {
                docId: di,
                docLabel: index + ": TYPE: " + state.items[di].Description + ", DOC ID: " + state.items[di].DocumentNumber,
                idCode: state.items[di].IdentityDocType,
                docNumber: state.items[di].DocumentNumber,
                Country: state.items[di].C_Country_ID,
                Nationality: state.items[di].Nationality_ID,
                RegionName: state.items[di].RegionName,
                Profession: state.items[di].Profession,
                IssueDate: state.items[di].IssueDate,
                ExpiryDate: state.items[di].ExpiryDate,
                DocumentID: state.items[di].GUB_BP_Document_ID
            };
            index++;
        }
    },
    setIdentityDocType(state, value) {
        state.item.IdentityDocType = value
    },
    setDocumentNumber(state, value) {
        state.item.DocumentNumber = value
    },
    setGUB_BP_Document_ID(state, value) {
        state.item.GUB_BP_Document_ID = value
    },
    setC_BPartner_ID(state, value) {
        state.item.C_BPartner_ID = value
    },
    setDescription(state, value) {
        state.item.Description = value
    },
    setExpiryDate(state, value) {
        state.item.ExpiryDate = value
    },
    setC_Country_ID(state, value) {
        state.item.C_Country_ID = value
    },
    setRegionName(state, value) {
        state.item.RegionName = value
    },
    setNationality_ID(state, value) {
        state.item.Nationality_ID = value
    },
    setProfession(state, value) {
        state.item.Profession = value
    },
    setIssueDate(state, value) {
        state.item.IssueDate = value
    },
    setLoading(state, loading) {
        state.docsLoading = loading
    },
    resetState(state) {
        state = Object.assign({}, initialState())
    }
}

export default {
    namespaced: true,
    state: initialState,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/IdentityDoc.js